import React, { useRef, useEffect } from "react";
import themePropTypes from "../theme-prop-types";

const Title = ({ title, name, forceFocus = false }) => {
  const titleRef = useRef();

  useEffect(() => {
    if (forceFocus) {
      titleRef.current.focus();
    }
  }, [forceFocus]);

  return (
    <h1
      className='title-web-sdk'
      tabIndex='-1'
      ref={titleRef}
      data-testid={`title-${name}`}
    >
      {title}
    </h1>
  );
};

Title.propTypes = themePropTypes.title;

export default Title;
